import { named, withDependencies } from '@wix/thunderbolt-ioc'
import {
	EditorFeatureConfigSymbol,
	LayoutChangeObserverSymbol,
	RenderDoneObserverSymbol,
	ILayoutChangeObserver,
	IRenderDoneObserver,
	LayoutDiagnosticService,
} from '@wix/thunderbolt-symbols'
import { name } from '../symbols'
import type { ViewerManagerLayoutApiEditorConfig } from '../types'

export const LayoutDiagnostic = withDependencies(
	[named(EditorFeatureConfigSymbol, name), RenderDoneObserverSymbol, LayoutChangeObserverSymbol],
	(
		{ shouldAccumulateComps }: ViewerManagerLayoutApiEditorConfig,
		renderDoneObserver: IRenderDoneObserver,
		layoutChangeObserver: ILayoutChangeObserver
	): LayoutDiagnosticService => {
		return {
			getDiagnosticState: () => {
				return {
					shouldAccumulateComps,
					...renderDoneObserver.getDiagnosticState(),
					...layoutChangeObserver.getDiagnosticState(),
				}
			},
		}
	}
)
